.spoke {
    margin-bottom: var(--spacer-40);

    .spokeHeader {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacer-16);
        margin-bottom: var(--spacer-24);
    }

    .spokeHeading {
        font: var(--font-h-24-forma);
    }

    @media print {
        &:has(.placeholder) {
            display: none;
        }
    }
}

.spokeMini {
    margin-bottom: var(--spacer-24);
    padding-inline: var(--spacer-40);
    padding-bottom: var(--spacer-24);
    border-bottom: 1px solid var(--gray-300);

    .spokeHeading {
        margin-bottom: var(--spacer-8);
        font: var(--font-p-20);
    }
}

.textLinkAdd {
    color: var(--gray-700);
    font: var(--font-text-link-14);
    text-decoration: underline;

    @media print {
        display: none;
    }
}

.placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--spacer-16);
    width: 100%;
    height: 300px;
    border: 1px solid var(--gray-500);
    color: var(--gray-900);
    font: var(--font-h-32);
}

.placeholderSvg {
    width: var(--spacer-24);
    height: var(--spacer-24);
    fill: currentColor;
}
